<template>
  <div style="padding:20px;background-color:white;margin:10px;height:calc(100% - 20px)">
    <el-button :loading="appLoad" class="t_btn" type="primary" @click="appreload">app刷新版本</el-button>
    <el-button :loading="appLoad" class="t_btn" type="primary" @click="appreloadZs">app追溯刷新版本</el-button>
    <el-button :loading="kvLoad" class="t_btn" type="primary" @click="kvreload">字典项刷新</el-button>
    <el-button :loading="hxpLoad" class="t_btn" type="primary" @click="hxpreload">化学品刷新</el-button>
    <el-button :loading="meanLoad" class="t_btn" type="primary" @click="meanreload">刷新菜单缓存</el-button>
    <el-button :loading="jsLoad" class="t_btn" type="primary" @click="jsreload">刷新角色菜单缓存</el-button>
    <el-button :loading="bmLoad" class="t_btn" type="primary" @click="bmreload">刷新部门缓存</el-button>
    <el-button :loading="xzqhLoad" class="t_btn" type="primary" @click="xzqhreload">刷新行政区划缓存</el-button>
    <el-button :loading="newsLoad" class="t_btn" type="primary" @click="newsreload">新闻中心缓存刷新</el-button>
    <el-button :loading="appkeyLoad" class="t_btn" type="primary" @click="appkeyreload">第三方开放平台刷新appkey</el-button>
    <el-button :loading="jsDsfLoad" class="t_btn" type="primary" @click="jsreloaddsf">第三方刷新角色菜单缓存</el-button>
    <el-button :loading="backIpLoad" class="t_btn" type="primary" @click="refreshBackIp">刷新黑名单</el-button>
    <el-button :loading="rateLimiterLoad" class="t_btn" type="primary" @click="refreshRateLimiter">刷新接口限制</el-button>
    <el-button :loading="rateLimiterLoad" class="t_btn" type="primary" @click="refreshSecretkeyLimiter">刷新密钥限制</el-button>
    <div class="push_switch">
      <span class="push_switch_label">垂管办件推送：</span>
      <el-switch
        v-model="cgUpProPushSwitch"
        :disabled="pushSwitchLoad"
        active-text="开启"
        inactive-text="关闭"
        @change="changePushSwitch"
      ></el-switch>
    </div>
  </div>
</template>

<script>

// 获取接口地址
import {
  appreload,
  kvreload,
  hxpreload,
  meanreload,
  jsreload,
  bmreload,
  xzqhreload,
  newsreload,
  appkeyreload,
  refreshBackIp,
  refreshRateLimiter,
  jsreloaddsf,
  appreloadZs,
  refreshSecretkeyLimiter,
  getCgUpProPushSwitch,
  setCgUpProPushSwitch
} from '@/assets/js/xtgl.js'

export default {
  name: 'Qtgl',
  components: {

  },
  data() {
    return {
      appLoad: false,
      kvLoad: false,
      hxpLoad: false,
      meanLoad: false,
      jsLoad: false,
      bmLoad: false,
      xzqhLoad: false,
      newsLoad: false,
      appkeyLoad: false,
      jsDsfLoad: false,
      backIpLoad: false,
      rateLimiterLoad: false,
      pushSwitchLoad: false,
      cgUpProPushSwitch: false
    }
  },
  created: function() {
    this.loadPushSwitch()
  },
  methods: {
    // 垂管办件推送开关
    loadPushSwitch() {
      getCgUpProPushSwitch().then((e) => {
        if (e.data.code == '000000') {
          this.cgUpProPushSwitch = !!e.data.data
        }
      }).catch(() => {
        this.cgUpProPushSwitch = false
      })
    },
    changePushSwitch(value) {
      this.pushSwitchLoad = true
      setCgUpProPushSwitch(value).then((e) => {
        this.pushSwitchLoad = false
        if (e.data.code == '000000') {
          this.$message.success(value ? '垂管办件推送已开启' : '垂管办件推送已关闭')
        } else {
          this.cgUpProPushSwitch = !value
        }
      }).catch(() => {
        this.pushSwitchLoad = false
        this.cgUpProPushSwitch = !value
      })
    },
    // app刷新版本
    appreload() {
      this.appLoad = true
      appreload().then((e) => {
        this.appLoad = false
      }).catch((e) => {
        console.log(e)
        this.appLoad = false
      })
    },
    // app追溯刷新版本
    appreloadZs() {
      this.appLoad = true
      appreloadZs().then((e) => {
        this.appLoad = false
      }).catch((e) => {
        console.log(e)
        this.appLoad = false
      })
    },
    // 字典项刷新
    kvreload() {
      this.kvLoad = true
      kvreload().then((e) => {
        this.kvLoad = false
      }).catch((e) => {
        console.log(e)
        this.kvLoad = false
      })
    },
    // 化学品刷新
    hxpreload() {
      this.hxpLoad = true
      hxpreload().then((e) => {
        this.hxpLoad = false
      }).catch((e) => {
        console.log(e)
        this.hxpLoad = false
      })
    },
    // 刷新菜单缓存
    meanreload() {
      this.meanLoad = true
      meanreload().then((e) => {
        this.meanLoad = false
      }).catch((e) => {
        console.log(e)
        this.meanLoad = false
      })
    },
    // 刷新角色菜单缓存
    jsreload() {
      this.jsLoad = true
      jsreload().then((e) => {
        this.jsLoad = false
      }).catch((e) => {
        console.log(e)
        this.jsLoad = false
      })
    },
    // 刷新第三方角色菜单缓存
    jsreloaddsf() {
      this.jsDsfLoad = true
      jsreloaddsf().then((e) => {
        this.jsDsfLoad = false
      }).catch((e) => {
        console.log(e)
        this.jsDsfLoad = false
      })
    },
    // 刷新部门缓存
    bmreload() {
      this.bmLoad = true
      bmreload().then((e) => {
        this.bmLoad = false
      }).catch((e) => {
        console.log(e)
        this.bmLoad = false
      })
    },
    // 刷新行政区划缓存
    xzqhreload() {
      this.xzqhLoad = true
      xzqhreload().then((e) => {
        this.xzqhLoad = false
      }).catch((e) => {
        console.log(e)
        this.xzqhLoad = false
      })
    },
    // 新闻中心缓存刷新
    newsreload() {
      this.newsLoad = true
      newsreload().then((e) => {
        this.newsLoad = false
      }).catch((e) => {
        console.log(e)
        this.newsLoad = false
      })
    },
    // 第三方开放平台刷新appkey
    appkeyreload() {
      this.appkeyLoad = true
      appkeyreload().then((e) => {
        this.appkeyLoad = false
      }).catch((e) => {
        console.log(e)
        this.appkeyLoad = false
      })
    },
    // 刷新黑名单
    refreshBackIp() {
      this.backIpLoad = true
      refreshBackIp().then((e) => {
        this.backIpLoad = false
      }).catch((e) => {
        console.log(e)
        this.backIpLoad = false
      })
    },
    // 刷新接口限制
    refreshRateLimiter() {
      this.rateLimiterLoad = true
      refreshRateLimiter().then((e) => {
        this.rateLimiterLoad = false
      }).catch((e) => {
        console.log(e)
        this.rateLimiterLoad = false
      })
    },
    // 刷新密钥限制
    refreshSecretkeyLimiter() {
      this.rateLimiterLoad = true
      refreshSecretkeyLimiter().then((e) => {
        this.rateLimiterLoad = false
      }).catch((e) => {
        console.log(e)
        this.rateLimiterLoad = false
      })
    }
  }
}
</script>

<style scoped>
  .t_btn{
    margin-left: 10px;
    margin-right:10px;
    margin-bottom: 10px;
  }
  .push_switch{
    margin: 20px 10px 0;
  }
  .push_switch_label{
    margin-right: 10px;
    color: #606266;
  }
</style>
